/* tslint:disable */
/* eslint-disable */
/**
 * Opus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MondayStatusChangeProjectMilestoneRequestPayload } from './MondayStatusChangeProjectMilestoneRequestPayload';
import {
    MondayStatusChangeProjectMilestoneRequestPayloadFromJSON,
    MondayStatusChangeProjectMilestoneRequestPayloadFromJSONTyped,
    MondayStatusChangeProjectMilestoneRequestPayloadToJSON,
} from './MondayStatusChangeProjectMilestoneRequestPayload';

/**
 * 
 * @export
 * @interface MondayStatusChangeProjectMilestoneRequest
 */
export interface MondayStatusChangeProjectMilestoneRequest {
    /**
     * 
     * @type {MondayStatusChangeProjectMilestoneRequestPayload}
     * @memberof MondayStatusChangeProjectMilestoneRequest
     */
    payload: MondayStatusChangeProjectMilestoneRequestPayload;
}

/**
 * Check if a given object implements the MondayStatusChangeProjectMilestoneRequest interface.
 */
export function instanceOfMondayStatusChangeProjectMilestoneRequest(value: object): value is MondayStatusChangeProjectMilestoneRequest {
    if (!('payload' in value) || value['payload'] === undefined) return false;
    return true;
}

export function MondayStatusChangeProjectMilestoneRequestFromJSON(json: any): MondayStatusChangeProjectMilestoneRequest {
    return MondayStatusChangeProjectMilestoneRequestFromJSONTyped(json, false);
}

export function MondayStatusChangeProjectMilestoneRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MondayStatusChangeProjectMilestoneRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'payload': MondayStatusChangeProjectMilestoneRequestPayloadFromJSON(json['payload']),
    };
}

export function MondayStatusChangeProjectMilestoneRequestToJSON(value?: MondayStatusChangeProjectMilestoneRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'payload': MondayStatusChangeProjectMilestoneRequestPayloadToJSON(value['payload']),
    };
}

